import styled from '@emotion/styled';
import { PillBadge } from '@lightspeed/flame/Badge';

export const NotificationBadge = styled(PillBadge)`
  font-size: 0.65rem;
  height: 20px;
  background-color: #ff0000;
  color: #ffffff;

  padding-left: 10px;
  padding-right: 10px;

  margin-right: 10px;
`;
